import SvgIcon, { SvgIconProps } from 'LuxKit/SvgIcon'

function LineBedKingIcon(props: SvgIconProps) {
  return <SvgIcon {...props} fill="none" viewBox="0 0 24 24">
    <path fill="currentColor" d="M20.9 10.5V6.1C20.9 5 20 4 18.8 4H5C3.8 4 2.9 5 2.9 6.1v4.4c-1 .4-1.8 1.5-1.8 2.7v4.2c0 .5.4.9.9.9h1v.8c-.1.5.3.9.8.9s.9-.4.9-.9v-.8h14.5v.8c0 .5.4.9.9.9s.9-.4.9-.9v-.8h1c.5 0 .9-.4.9-.9v-4.2c-.2-1.2-1-2.3-2-2.7Zm-8.1-1.1c0-.2.2-.4.4-.4h3.1c.2 0 .4.2.4.4v.9h-3.9v-.9Zm-5.6 0c0-.3.2-.4.4-.4h3.1c.2 0 .4.2.4.4v.9H7.2v-.9Zm9-2.2h-3.1c-.5 0-.9.2-1.3.4-.4-.3-.8-.4-1.3-.4H7.6c-1.2 0-2.1 1-2.1 2.2v.9h-.9V6.1c0-.2.1-.3.3-.3h13.9c.2 0 .3.1.3.3v4.2h-.8v-.9c0-1.2-.9-2.2-2.1-2.2Zm4.8 6v3.3H2.8v-3.3c0-.6.5-1.1 1-1.1h16.1c.6 0 1.1.5 1.1 1.1Z"/>
  </SvgIcon>
}

export default LineBedKingIcon
